<form novalidate name="summaryEmailModal.oqsContactEmail" ng-submit="summaryEmailModal.ok()">
  <div class="modal-header oqs-summary-modal-header">
    <button type="button" class="close" ng-click="summaryEmailModal.cancel()" aria-label="Close">
      <span aria-hidden="true">&times;</span>
    </button>
    <h4 class="modal-title" oqs-message="emailDialog.heading.emailDialogHeading" oqs-message-html></h4>
  </div>

  <div class="modal-body oqs-summary-modal-body">
    <p oqs-message="emailDialog.text.emailDialogBody" oqs-message-html></p>
    <div>
      <div class="form-group">
        <label for="emailAddress">Your email address?</label>
        <input ng-model="summaryEmailModal.contactInfo.emailAddress" class="form-control"  id="emailAddress" type="email"
               ng-pattern="summaryEmailModal.emailPattern"
               ng-required="true"
               placeholder="you@domain.com" autofocus/>
      </div>
    </div>
    <uib-alert type="danger" ng-if="summaryEmailModal.data.quoteSummaryEmailResponse && summaryEmailModal.data.quoteSummaryEmailResponse.status!=200">
      <span class="fa fa-exclamation"></span> <span oqs-message="emailDialog.html.emailError" oqs-message-html></span>
    </uib-alert>
    <uib-alert type="success" ng-if="summaryEmailModal.data.quoteSummaryEmailResponse && summaryEmailModal.data.quoteSummaryEmailResponse.status==200">
      <span class="fa fa-check"></span> <span oqs-message="emailDialog.html.emailSuccessful" oqs-message-html></span>
    </uib-alert>
  </div>
  <div class="modal-footer">
    <button type="submit"
            class="btn"
            ng-class="{'btn-default': summaryEmailModal.isSubmitDisabled(), 'btn-primary': !summaryEmailModal.isSubmitDisabled()}"
            ng-disabled="summaryEmailModal.isSubmitDisabled()">
      <span oqs-message="emailDialog.button.emailSubmitButton"></span>
    </button>
    <button class="btn btn-default" type="button"
            ng-click="summaryEmailModal.cancel()" >
      <span oqs-message="emailDialog.button.emailCancelButton">Cancel</span>
    </button>
  </div>
</form>
